import React, { useState, useEffect } from 'react';
import { Filter, ShoppingBag } from 'lucide-react';
import { PetMarket } from './market/PetMarket';
import { ItemMarket } from './market/ItemMarket';
import type { User } from '../../types/user';

interface MarketplaceProps {
  user: User | null;
}

export function Marketplace({ user }: MarketplaceProps) {
  const [activeSection, setActiveSection] = useState<'pets' | 'items'>('pets');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div className="flex gap-4">
          <button
            onClick={() => setActiveSection('pets')}
            className={`px-4 py-2 rounded-lg font-serif flex items-center gap-2
              ${activeSection === 'pets' 
                ? 'bg-gradient-to-r from-purple-600 to-pink-500 text-white' 
                : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}
          >
            Pets
          </button>
          <button
            onClick={() => setActiveSection('items')}
            className={`px-4 py-2 rounded-lg font-serif flex items-center gap-2
              ${activeSection === 'items'
                ? 'bg-gradient-to-r from-purple-600 to-pink-500 text-white'
                : 'bg-gray-800 text-gray-300 hover:bg-gray-700'}`}
          >
            Items
          </button>
        </div>

        <div className="flex items-center gap-2 bg-gray-800 px-4 py-2 rounded-lg">
          <ShoppingBag className="w-5 h-5 text-yellow-400" />
          <span className="text-yellow-400 font-mono">
            {user?.points.toLocaleString() || 0} coins
          </span>
        </div>
      </div>

      {activeSection === 'pets' ? (
        <PetMarket user={user} />
      ) : (
        <ItemMarket user={user} />
      )}
    </div>
  );
}